import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DarkBg from '@/components/dark-bg.vue';
import LookVideoDialog from '@/components/look-video-dialog.vue';
import IframeServer from '@/views/iframe-server/index';
import { getVideoUrl } from '@/utils/guide-video';
import { getFirstGuide, guideQuery } from '@/api/modules/guide';
export default {
  components: {
    DarkBg: DarkBg,
    LookVideoDialog: LookVideoDialog
  },
  data: function data() {
    return {
      showVideoDialog: false,
      dialogUrl: '',
      dialogTitle: '分册',
      guidance: {
        study: {},
        exercise: {},
        question: {}
      },
      playImg: this.$resource('icon_video_play.png'),
      isFirstEnter: false
    };
  },
  watch: {
    showVideoDialog: function showVideoDialog(val) {
      if (!val) {
        this.isFirstEnter = false;
      }
    }
  },
  created: function created() {
    this.isFirstToStudy();
    this.getGuideInfo();
  },
  methods: {
    // 查看是否是首次进入学习页
    isFirstToStudy: function isFirstToStudy() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$getFirstGuide, data, status;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getFirstGuide({
                  code: 'V0003'
                });

              case 2:
                _yield$getFirstGuide = _context.sent;
                data = _yield$getFirstGuide.data;
                status = _yield$getFirstGuide.status;

                if (!(status !== 1 || !data || !data.content)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                // 自动播放首次学习页视频
                _this.playVideo(data);

                _this.isFirstEnter = true;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 使用引导信息
    getGuideInfo: function getGuideInfo() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$guideQuery, data, status;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return guideQuery({
                  codes: ['C0012']
                });

              case 2:
                _yield$guideQuery = _context2.sent;
                data = _yield$guideQuery.data;
                status = _yield$guideQuery.status;

                if (!(status !== 1 || !(data !== null && data !== void 0 && data[0]))) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return");

              case 7:
                _this2.guidance = JSON.parse(data[0].content || '{}');

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 播放视频
    playVideo: function playVideo(video) {
      this.dialogUrl = getVideoUrl(video);
      this.dialogTitle = video.videoName;
      this.showVideoDialog = true;
    },
    clickQuestion: function clickQuestion(question) {
      this.$showModal(IframeServer, {
        url: question.url,
        iframeName: 'guide'
      }, {
        width: '800px',
        noFooter: true,
        customClass: 'guide-dialog'
      });
    },
    moreQuestion: function moreQuestion() {
      var routeUrl = this.$router.resolve({
        name: 'helpCenter',
        query: {
          url: localStorage.getItem('helpCenterUrl')
        }
      });
      window.open(routeUrl.href, '_blank');
    }
  }
};